import { vSales } from './view.js';
import { actions, changes } from './actions.js';
import { initDealDnd } from './dnd.js';

export default {
  id: 'sales', label: 'Sales', icon: 'sales', nav: true,
  show: (u) => u.dept.includes('sales'),
  view: vSales, actions, changes,
  init() { initDealDnd(); }
};
